<template>
  <div class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">
        {{ route.params.id ? 'Editar Desconto' : 'Novo Desconto' }}
      </h4>
      <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
    </div>

    <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarDesconto" @cancel="voltar">
      <!-- Dados do Desconto -->
      <FormSection title="Informações do Desconto">
        <InputField
          v-model="desconto.descricao"
          label="Descrição <span class='required'>*</span>"
          id="descricao"
          placeholder="Digite a descrição do desconto"
          required
          width="400px"
        />

        <InputField
          v-model="desconto.desconto"
          label="Desconto (%) <span class='required'>*</span>"
          id="desconto"
          placeholder="Digite o percentual de desconto"
          required
          type="number"
        />

        <div class="form-group">
          <label for="ativo">Status <span class="required">*</span></label>
          <div class="form-switch">
            <input
              type="checkbox"
              id="ativo"
              v-model="desconto.ativo"
              class="form-check-input"
            />
            <label for="ativo" class="form-check-label">
              {{ desconto.ativo ? 'Ativo' : 'Inativo' }}
            </label>
          </div>
        </div>
      </FormSection>
    </BaseForm>
  </div>
</template>

<script>
import { reactive, ref, computed, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputField from '@/components/Layout/InputField.vue';
import FormSection from '@/components/Layout/FormSection.vue';
import BaseForm from '@/components/Layout/BaseForm.vue';
import axios from '@/services/axios';

export default {
  components: { InputField, FormSection, BaseForm },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { appContext } = getCurrentInstance();
    const userName = appContext.config.globalProperties.$globalState.userName;

    const desconto = reactive({
      id: null,
      descricao: '',
      desconto: null,
      ativo: true,
      por: userName,
    });

    const isSubmitting = ref(false);
    const isFormValid = computed(() =>
      desconto.descricao.trim() !== '' &&
      desconto.desconto !== null &&
      desconto.desconto >= 0 &&
      desconto.desconto <= 100
    );

    const novoDesconto = () => {
      Object.assign(desconto, { descricao: '', desconto: null, ativo: true, por: userName });
      isSubmitting.value = false;
    };

    const salvarDesconto = async () => {
      if (isSubmitting.value || !isFormValid.value) return;
      isSubmitting.value = true;
      try {
        // garante que 'por' esteja sempre atualizado
        desconto.por = userName;
        const method = desconto.id ? 'put' : 'post';
        const url = desconto.id
          ? `/cadastros/descontos/${desconto.id}`
          : '/cadastros/descontos';

        await axios[method](url, {
          descricao: desconto.descricao,
          desconto: parseFloat(desconto.desconto),
          ativo: desconto.ativo,
          por: desconto.por,
        });
        router.push('/cadastros/descontos');
      } catch (error) {
        console.error('Erro ao salvar desconto:', error.response?.data || error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const voltar = () => router.push('/cadastros/descontos');

    onMounted(async () => {
      const id = route.params.id;
      if (id) {
        try {
          const res = await axios.get(`/cadastros/descontos/${id}`);
          Object.assign(desconto, res.data, { por: userName });
        } catch (error) {
          console.error('Erro ao carregar desconto:', error);
        }
      } else {
        novoDesconto();
      }
    });

    return { desconto, isSubmitting, isFormValid, salvarDesconto, voltar, route };
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
